import { createRequestTypes } from '../utils';

export const PHRASE_TRANSLATION_LIST = createRequestTypes('phraseTranslation/PHRASE_TRANSLATION_LIST');
export const SAVE_TRANSLATION = createRequestTypes('phraseTranslation/SAVE_TRANSLATION');
